import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateDiscountSingle = {
  discountSingle: { data: null, loading: false, error: null },
};

export const discountSingle = createAsyncThunk('user/discountSingle', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/discount/${data.id}`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerDiscountSingle = {
  [discountSingle.pending]: (state) => {
    state.discountSingle.loading = true;
  },
  [discountSingle.fulfilled]: (state, action) => {
    state.discountSingle.loading = false;
    state.discountSingle.data = action.payload;
    state.discountSingle.error = null;
  },
  [discountSingle.rejected]: (state, action) => {
    state.discountSingle.data = null;
    state.discountSingle.loading = false;
    state.discountSingle.error = action.payload;
  },
};
